import {
  BiHomeAlt,
  BiBookmarkAlt,
  BiSolidMegaphone,
  BiFile,
  BiBookOpen,
} from "react-icons/bi";

export const menuItem = [
  {
    id: 1,
    name: "Dashboard",
    Icon: BiHomeAlt,
    link: "/dashboard",
  },
  {
    id: 2,
    name: "Add Tickets",
    Icon: BiBookmarkAlt,
    link: "/createticket",
  },
  {
    id: 2,
    name: "View Tickets",
    Icon: BiBookmarkAlt,
    link: "/tickets",
  },
  {
    id: 3,
    name: "Announcement",
    Icon: BiSolidMegaphone,
    link: "/announcement",
  },
  {
    id: 4,
    name: "Circular",
    Icon: BiFile,
    link: "/circular",
  },
  {
    id: 5,
    name: "User Manual",
    Icon: BiBookOpen,
    link: "/usermannual",
  },
];
